import Box from "@mui/material/Box";

// import { useDispatch } from "react-redux";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const root_ = (theme) => ({
  padding: "20px",
  "& .MuiTypography-overline": {
    lineHeight: 1.25,
    letterSpacing: "0.03em",
  },
  "& .MuiButton-label": {
    color: "black",
  },
});

const temp_ = (theme) => ({
  // display: 'flex',
  // justifyContent: 'space-between',
  marginBottom: "10px",
  fontSize: "1rem",
});

const stack_ = (theme) => ({
  flexGrow: "1",
  display: "inline-block",
  "& .MuiButton-root": {
    lineHeight: 1,
  },
  "& .MuiTypography-overline": {
    lineHeight: 1,
  },
});

const primary_ = (theme) => ({
  fontWeight: "bold",
  letterSpacing: 0,
  fontSize: "0.7rem",
});

const secondary_ = (theme) => ({
  color: "grey",
  fontSize: "0.6rem",
  letterSpacing: "0 !important",
});

const clickable_ = (theme) => ({
  color: "rgb(0, 100, 177)",
  "&:hover": {
    textDecoration: "underline",
  },
});

export default function RestroomLayerInfo({ room = {} }) {
  // const dispatch = useDispatch();

  const {
    rmnbr,
    institutional_intent,
    user_type,
    gender_designation,

    accessible_room,
    countertops,

    num_toilets,
    num_urinals,
    num_sinks,
    num_showers,
    num_lockers,
    num_breast_pump,

    changing_table,
    menstrual_products,
  } = room;

  const formatOutput = (attr) => {
    if (rmnbr && attr === undefined) {
      return "NO DATA";
    } else if (rmnbr && attr) {
      return attr;
    } else {
      return "";
    }
  };

  const isVisible = { visibility: rmnbr ? "visible" : "hidden" };

  return (
    <Box sx={root_}>
      <Box style={isVisible}>
        <Box sx={temp_}>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                ROOM
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {rmnbr}
                </Box>
              </Button>
            </Typography>
          </Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                Gender{" "}
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              {/* <Tooltip title={`Search ${rmtyp_descrshort.toUpperCase()} in ${bld_descrshort}`}> */}
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(gender_designation)}
                </Box>
              </Button>
              {/* </Tooltip> */}
            </Typography>
          </Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                Intent{" "}
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(institutional_intent)}
                </Box>
              </Button>
            </Typography>
          </Box>
        </Box>

        <Box sx={temp_}>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                Accessible
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              {/* <Tooltip title={`Search ${rmtyp_descrshort.toUpperCase()} in ${bld_descrshort}`}> */}
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(accessible_room)}
                </Box>
              </Button>
              {/* </Tooltip> */}
            </Typography>
          </Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                Countertops{" "}
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              {/* <Tooltip title={`Search ${rmtyp_descrshort.toUpperCase()} in ${bld_descrshort}`}> */}
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(countertops)}
                </Box>
              </Button>
              {/* </Tooltip> */}
            </Typography>
          </Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                TYPE{" "}
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              {/* <Tooltip title={`Search ${rmtyp_descrshort.toUpperCase()} in ${bld_descrshort}`}> */}
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(user_type)}
                </Box>
              </Button>
              {/* </Tooltip> */}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                Changing Table{" "}
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              {/* <Tooltip title={`Search ${rmtyp_descrshort.toUpperCase()} in ${bld_descrshort}`}> */}
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(changing_table)}
                </Box>
              </Button>
              {/* </Tooltip> */}
            </Typography>
          </Box>
          <Box sx={stack_}>
            <Typography component="div" variant="overline">
              <Box component="span" sx={secondary_}>
                Menstrual Product{" "}
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              {/* <Tooltip title={`Search ${rmtyp_descrshort.toUpperCase()} in ${bld_descrshort}`}> */}
              <Button
                size="small"
                style={{
                  padding: "0px",
                  minWidth: "auto",
                  fontSize: "inherit",
                }}
                // onClick={searchRoomtype}
                sx={clickable_}
              >
                <Box
                  component="span"
                  sx={primary_}
                  data-testid="info-room-rmtyp-name"
                >
                  {formatOutput(menstrual_products)}
                </Box>
              </Button>
              {/* </Tooltip> */}
            </Typography>
          </Box>
        </Box>

        <Box style={{ marginTop: "15px", marginBottom: "10px" }}>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography
              component="div"
              variant="overline"
              style={{ marginBottom: "4px" }}
            >
              <Box component="span" sx={primary_} data-testid="info-room-sqft">
                {formatOutput(num_toilets)}
              </Box>
              <Box
                component="span"
                sx={secondary_}
                style={{ marginLeft: "2px" }}
              >
                Toilets
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              <Box
                component="span"
                sx={primary_}
                data-testid="info-room-rmstationcnt"
              >
                {formatOutput(num_urinals)}
              </Box>
              <Box
                component="span"
                sx={secondary_}
                style={{ marginLeft: "2px" }}
              >
                Urinals
              </Box>
            </Typography>
          </Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography
              component="div"
              variant="overline"
              style={{ marginBottom: "4px" }}
            >
              <Box component="span" sx={primary_} data-testid="info-room-sqft">
                {formatOutput(num_sinks)}
              </Box>
              <Box
                component="span"
                sx={secondary_}
                style={{ marginLeft: "2px" }}
              >
                Sinks
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              <Box
                component="span"
                sx={primary_}
                data-testid="info-room-rmstationcnt"
              >
                {num_showers}
              </Box>
              <Box
                component="span"
                sx={secondary_}
                style={{ marginLeft: "2px" }}
              >
                Showers
              </Box>
            </Typography>
          </Box>
          <Box sx={stack_} style={{ width: "31%" }}>
            <Typography
              component="div"
              variant="overline"
              style={{ marginBottom: "4px" }}
            >
              <Box component="span" sx={primary_} data-testid="info-room-sqft">
                {formatOutput(num_lockers)}
              </Box>
              <Box
                component="span"
                sx={secondary_}
                style={{ marginLeft: "2px" }}
              >
                Lockers
              </Box>
            </Typography>
            <Typography component="div" variant="overline">
              <Box
                component="span"
                sx={primary_}
                data-testid="info-room-rmstationcnt"
              >
                {formatOutput(num_breast_pump)}
              </Box>
              <Box
                component="span"
                sx={secondary_}
                style={{ marginLeft: "2px" }}
              >
                Breast Pumps
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
